export default __webpack_public_path__ + "static/media/1562.e52ff9cc.png";